import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './no_active_positions.component.css';

const NoActivePositions = () => {
  return (
    <div className="no-data-banner">
      <div className="px-4">
        <FontAwesomeIcon icon={faExclamationCircle} />
      </div>
      <div>
        <h4 className="title">No Active Positions</h4>
        <p className="info">
          Your portfolio doesn't have any active companies or ETFs
        </p>
      </div>
    </div>
  );
};

export default NoActivePositions;
